import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';

const path = name => `app/pages/taskList/${name}`;
const models = {
    type: {
        data:1,
        handlers: {
            updateType(state, action) {
               return  action.payload;
            },
        },
    },
    proxyinfo: {
        data: [],
        handlers: {
            getProxyInfo(state, action) {
                return action.payload;
            },
        },
    },
    proxyrepeatinfo: {
        data: {
            list: [],
            map: {},
        },
        handlers: {
            get(state, action) {
                console.log('repeatupdate====')
                return action.payload;
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 20,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {
            provinceId: '',
            cityId: '',
            agentName: '',
            day: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isRepeatLoading: false,
            isAgentLoading: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
    provinces: {
        data: [],
        handlers: {
            getProvince(state, action) {
                return action.payload;
            },
        },
    },
    citys: {
        data: [],
        handlers: {
            getCityes(state, action) {
                return action.payload;
            },
        },
    },
    agents: {
        data: [],
        handlers: {
            getAgents(state, action) {
                return action.payload;
            },
        },
    },
    agentsGroup: {
        data: [],
        handlers: {
            getAgentsGroup(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export const agencyAnalysis = combineReducers(createReducers(models, path));

// 获取省市接列表
export const getProvinceAndAgent = () => {
    return async (dispatch, getState) => {
        try {
            let partnerUrl = Urls.PartnerUrl;
            // 获取省市接口
            const provinceUrl = Urls.TaskUrl.province;
            let [provinceInfo, proxyInfo] = await Promise.all([request(provinceUrl), request(partnerUrl.slist + 'page=1&pageSize=1000')]);
            const provinces = provinceInfo.slice(0, 34);
            const cities = provinceInfo.slice(35);
            dispatch(actions.getProvince(provinces));
            dispatch(actions.getCityes(cities));
            dispatch(actions.getAgents(proxyInfo));
        } catch (e) {
            throw new Error(e);
        }
    };
};
// 格式化搜索项
const formatParams = values => {
    let list = [];
    for (let i in values) {
        if (typeof values[i] !== 'undefined' && values[i]) {
            list.push(`${i}=${values[i]}`);
        }
    }
    return list.join('&');
};

// 获取代理商详细信息（表格数据）
export const getProxyInfo = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            // 获取代理商详情接口
            const getProxyInfoUrl = Urls.PartnerUrl.getProxyInfo;

            let values = getState().agencyAnalysis.searchValues;
            // 获取查询条件
            let response = await request(getProxyInfoUrl + formatParams(values));
            // console.log('response=====', response);
            // // 假数据
            // response = [{
            //     "agent": null,
            //     "area": "北京市",
            //     "tm": "2018-07-07",
            //     "tr": 0,
            //     "errorClickCount": 10,
            //     "successClickCount": 20,
            //     "errorEvCount": 10,
            //     "successEvCount": 20,
            //     "ipDistinctCount": 338,
            //     "ipCount": 1000,
            //     "usedCount": 800,
            //     "cityId": 0,
            //     "provinceId": 0,
            //     "time": "2018-07-07 00:00"
            // }, {
            //     "agent": null,
            //     "area": "北京市",
            //     "tm": "2018-07-07",
            //     "tr": 0,
            //     "errorClickCount": 10,
            //     "successClickCount": 20,
            //     "errorEvCount": 10,
            //     "successEvCount": 20,
            //     "ipDistinctCount": 338,
            //     "ipCount": 1000,
            //     "usedCount": 800,
            //     "cityId": 0,
            //     "provinceId": 0,
            //     "time": "2018-07-07 01:00"
            // }];
            response = response.map(item => {
                let {errorClickCount, successClickCount, errorEvCount, successEvCount, ipCount, ipDistinctCount} = item;
                let ratio = 0;
                if (ipCount) {
                    ratio = (ipDistinctCount / ipCount * 100).toFixed(2);
                }
                let total = errorClickCount + successClickCount + errorEvCount + successEvCount;
                let clickTotal = errorClickCount + successClickCount;
                let evTotal = errorEvCount + successEvCount;
                let errorTotal = errorClickCount + errorEvCount;
                let totalErrorR = 0;
                let clickErrorR = 0;
                let evErrorR = 0;
                if (total) {
                    totalErrorR = (errorTotal / total * 100).toFixed(2);
                }
                if (clickTotal) {
                    clickErrorR = (errorClickCount / clickTotal * 100).toFixed(2);
                }
                if (evTotal) {
                    evErrorR = (errorEvCount / evTotal * 100).toFixed(2);
                }
                return {
                    ...item,
                    ratio, // 新增IP比率
                    total, // 任务使用IP总数
                    totalErrorR, // 出错IP比率
                    clickTotal, // 点击任务使用IP数
                    clickErrorR, // 出错IP比率
                    evTotal, // 曝光任务使用IP数
                    evErrorR, // 出错IP比率
                };
            });
            dispatch(actions.getProxyInfo(response));
        } catch (e) {
            message.error(e);
            throw new Error(e);
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};

// 获取代理商重复信息（表格数据）
export const getProxyRepeatInfo = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isRepeatLoading: false}));
            // 获取代理商重复信息接口
            const getProxyRepeatInfoUrl = Urls.PartnerUrl.getProxyRepeatInfo;
            let values = getState().agencyAnalysis.searchValues;
            let response = await request(getProxyRepeatInfoUrl + formatParams(values));
            console.log('repeat===', response);
            dispatch(actions.get(response));
            return response;
        } catch (e) {
            message.error(e.message);
            throw new Error(e);
        } finally {
            dispatch(actions.changeUiStatus({isRepeatLoading: false}));
        }
    };
};

// 获取代理商维度的IP数据
export const getAgentsProxyInfo = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isAgentLoading: true}));
            const getAgentProxyInfo = Urls.PartnerUrl.getAgentProxyInfo;
            let values = getState().agencyAnalysis.searchValues;
            let proxyInfo = await request(getAgentProxyInfo + formatParams(values));
            // console.log('proxyInfo========', proxyInfo)
            proxyInfo = _.chain(proxyInfo)
                .map((d, agent) => {
                    let errorClickCountT =  _.sumBy(d, 'errorClickCount');
                    let successClickCountT = _.sumBy(d, 'successClickCount');
                    let clickTotal = errorClickCountT + successClickCountT;
                    let errorEvCountT =  _.sumBy(d, 'errorEvCount');
                    let successEvCountT = _.sumBy(d, 'successEvCount');
                    let blackIpCount = _.sumBy(d,'blackIpCount');
                    let evTotal = errorEvCountT + successEvCountT;
                    let total = clickTotal + evTotal;
                    let totalErrorR =  total ? ((errorClickCountT + errorEvCountT) / total * 100).toFixed(2) : 0;
                    let evErrorR = evTotal ? (errorEvCountT / evTotal * 100).toFixed(2) : 0;
                    let clickErrorR = clickTotal ? (errorClickCountT / clickTotal * 100).toFixed(2) : 0;
                    let repeatCountT = _.sumBy(d, 'repeatCount');
                    let ipDistinctCountT = _.sumBy(d, 'ipDistinctCount');
                    let ratio = ipDistinctCountT ? (repeatCountT / ipDistinctCountT * 100).toFixed(2) : 0;
                    let bandWidth = d[0].bandWidth;
                    d = d.map(item => {
                        let {errorClickCount, successClickCount, errorEvCount, successEvCount, repeatCount, ipDistinctCount} = item;
                        let total = errorClickCount + successClickCount + errorEvCount + successEvCount;
                        let clickTotal = errorClickCount + successClickCount;
                        let evTotal = errorEvCount + successEvCount;
                        let errorTotal = errorClickCount + errorEvCount;
                        let totalErrorR = 0;
                        let clickErrorR = 0;
                        let evErrorR = 0;
                        let ratio = 0;
                        if (total) {
                            totalErrorR = (errorTotal / total * 100).toFixed(2);
                        }
                        if (ipDistinctCount) {
                            ratio = (repeatCount / ipDistinctCount * 100).toFixed(2);
                        }
                        if (clickTotal) {
                            clickErrorR = (errorClickCount / clickTotal * 100).toFixed(2);
                        }
                        if (evTotal) {
                            evErrorR = (errorEvCount / evTotal * 100).toFixed(2);
                        }
                        return {
                            ...item,
                            ratio, // 新增IP比率
                            total, // 任务使用IP总数
                            totalErrorR, // 出错IP比率
                            clickTotal, // 点击任务使用IP数
                            clickErrorR, // 出错IP比率
                            evTotal, // 曝光任务使用IP数
                            evErrorR, // 出错IP比率
                        };
                    });
                    return {
                        time: `${agent}`,
                        repeatCount: repeatCountT,
                        errorClickCount: errorClickCountT,
                        successClickCount: successClickCountT,
                        errorEvCount: errorEvCountT,
                        successEvCount: successClickCountT,
                        ipDistinctCount: ipDistinctCountT,
                        total,
                        totalErrorR,
                        clickTotal,
                        clickErrorR,
                        evTotal,
                        evErrorR,
                        ratio,
                        blackIpCount,
                        detail: d,
                        key: agent,
                        bandWidth: bandWidth,
                    };
                })
                .flattenDeep()
                .value();
            // console.log('proxyInfo===', proxyInfo);
            dispatch(actions.getAgentsGroup(proxyInfo));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(actions.changeUiStatus({isAgentLoading: false}));
        }
    };
};



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/reducers.js